/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../components/header/index'
import Hero from '../components/heros/index'
import Container from '../components/container'
import Card from '../components/jobCard'
import Footer from '../components/footer'
import Title from '../components/title'

const Jobs = () => {
    Title('Jobs - StellaNode')

    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Job Openings' description='Want to be a part of our team? View our available job openings below' />
            </div>
            <section className="jobs py-32">
                <Container>
                    <div className="grid grid-cols-1 gap-7">
                        <Card title='Junior Sales Representative' tags={['Commission-Based', 'Remote Only', 'Benefits']} price='0' link='https://docs.google.com/forms/d/e/1FAIpQLSfXjLxKdFPd8hX1UoYK92JsiF1Uu1H2du9YkBsRcoCbjUOzbw/viewform'>
                            <p className="text-gray-300 mb-2.5">
                            Whether you're just looking to make some quick cash, or even just gain experience, this is the perfect position for you. No prior experience is required, you will get your own vanity coupon code on our services and will be paid 75% of every purchase made with it.
                            </p>
                            <h1 className='text-2xl text-gray-100 font-medium mb-5'>Requirements</h1>
                            <ul className='list-disc mb-3'>
                                <li className='text-gray-300'>
                                    At least 16 years old
                                </li>
                                <li className='text-gray-300'>
                                    Enthusiastic, friendly, and willing to follow the rules of our company
                                </li>
                                </ul>
                        </Card>
                        <Card title='Developer (No Openings)' tags={['Part-Time', 'Remote Only', 'Benefits']} price='200' link='https://docs.google.com/forms/d/e/1FAIpQLSfRHDWYX2j-wEeZkH3fz6MuyidwJNUBHTarbbbVGNQSvQaBDA/viewform'>
                            <p className="text-gray-300 mb-2.5">
                            Developers will be working on developing and maintaining our Pterodactyl Panel along with our website. This includes updating addons to new Pterodactyl release versions and developing custom addons for our panel both frontend and backend. Our panel will be developed off of what Pterodactyl natively supports. As a result, additions like CSS patches will not be used.
                            </p>
                            <h1 className='text-2xl text-gray-100 font-medium mb-5'>Requirements</h1>
                            <ul className='list-disc mb-3'>
                                <li className='text-gray-300'>
                                    At least 16 years old
                                </li>
                                <li className='text-gray-300'>
                                    Enthusiastic, friendly, and willing to follow the rules of our company
                                </li>
                                <li className='text-gray-300'>
                                    Extensive knowledge of the Pterodactyl backend code and TypeScript (along with React)
                                </li>
                                </ul>
                        </Card>
                        <Card title='Customer Support Representative (No Openings)' tags={['Part-Time', 'Remote Only', 'Benefits']} price='25' link='https://docs.google.com/forms/d/e/1FAIpQLSfr4ufeGvyplPC3jAlSuosGPwFI5sFa6CsFnOgJzhf7UdykJQ/viewform'>
                            <p className="text-gray-300 mb-2.5">
                            Customer Support Representatives must be very knowledgeable about Minecraft servers and the technical workings such as plugins, mods, and server configurations. If you have experience troubleshooting plugin issues, mod failures, and BungeeCord servers, you are our perfect candidate.
                            </p>
                            <h1 className='text-2xl text-gray-100 font-medium mb-5'>Requirements</h1>
                            <ul className='list-disc mb-3'>
                                <li className='text-gray-300'>
                                    At least 16 years old
                                </li>
                                <li className='text-gray-300'>
                                    Active in Live Chat and Discord support chats/tickets
                                </li>
                                <li className='text-gray-300'>
                                    Enthusiastic, friendly, and willing to follow the rules of our company
                                </li>
                                </ul>
                            <br></br>
                            <p className="text-gray-300">
                            We have systems in place to increase the frequency with which community support is provided in our Discord. With community support in action (customer-on-customer support), our Support Agents are relieved of the pressure of providing constant support. All assistance should be minor and limited to a few times per day.
                            </p>
                        </Card>
                        {/*<Card title='Support Representative' tags={['Full-time', 'Remote Only', 'Benefits']} price='25' link='https://billing.stellanode.com/submitticket.php'>
                            <p className="text-gray-300 mb-2.5">
                                Support related to billing and other non game server issues are handled by executes via our online ticket system. All Game Server related complications must be dealt with via our discord server. As a support Representative you must be ready to give support to customers multiple times a day.
                            </p>
                            <p className="text-gray-300">
                                We have systems in place to make community support occur much more often. With community support in action (Customer on customer support), that takes a lot of pressure off our Support Representatives to give constant support. All support given should be minor and happen only a few times per day.
                            </p>
                        </Card>
                        <Card title='Senior Sales Representative' tags={['Part-time', 'Remote Only', 'Benefits']} price='25' link='https://billing.stellanode.com/submitticket.php'>
                            <p className="text-gray-300 mb-2.5">
                                As a Senior Sales Representative, your number one mission is to seek as many sales for the company as you can. You must be able to bring in a minimum of 10 sales each month.
                            </p>
                            <p className="text-gray-300">
                                Each Sales Representative will recieve their own affiliation link to give all customers they reffer. When the customer uses this link, it will store a cookie in their browser letting the system know you reffered them. You will get 10% of each sale you make (First month only), on top of your monthly salary.
                            </p>
                        </Card>
                        <Card title='Social Media Manager' tags={['Full-time', 'Remote Only', 'Benefits']} price='25' link='https://billing.stellanode.com/submitticket.php'>
                            <p className="text-gray-300 mb-2.5">
                                In charge of running all StellaNode official social media accounts. This includes Twitter, Facebook, and TikTok (More will be added in the future, so be aware of this). Your primary responsability will be to come up with multiple posts per week for each of our social media accounts.
                            </p>
                            <p className="text-gray-300">
                                If support is ever asked for via these social accounts, you must be prepared each day to log on and reply. Under this role, you must also plan out fun events and giveaways for the community every month.
                            </p>
                        </Card>*/}
                    </div>
                </Container>
            </section>
            <Footer />
        </main>
    )
}

export default Jobs